<template>
  <v-snackbar
    :value="pending !== null"
    :timeout="-1"
    bottom
    left
    color="secondary"
  >
    <span v-if="pending">
      {{ $t("removed_item", { name: pending.label }) }}
    </span>

    <template v-slot:action="{ attrs }">
      <span v-if="secondsLeft > 0" class="mr-2 text--disabled">{{ secondsLeft }}</span>
      <v-btn
        text
        color="primary"
        v-bind="attrs"
        @click="$emit('undo')"
      >
        {{ $t("undo") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
/*
 * The bar shown while a removal can still be taken back.
 * Pairs with the `undoable` mixin: the parent passes its `pendingUndo` and
 * `undoSecondsLeft` in, and handles @undo with `undoPendingRemove`.
 */
export default {
  name: "UndoBar",
  props: {
    pending: {
      type: Object,
      default: null,
    },
    secondsLeft: {
      type: Number,
      default: 0,
    },
  },
};
</script>
